<!-- FounderWelcomeModal.vue
     Boas-vindas pessoal do fundador, no primeiro acesso ao sistema.
     Mesma mensagem do e-mail de boas-vindas, com o link do WhatsApp de
     suporte já preenchido com quem é a pessoa e onde ela está.
     Qualquer forma de fechar (X, Esc, fundo, botões) conta como dispensar:
     o DashboardLayout grava no backend e o modal não volta mais.
-->

<script setup>
import { onMounted, onBeforeUnmount } from "vue";

defineProps({
  // Primeiro nome para a saudação; vazio cai em "Olá!".
  firstName: { type: String, default: "" },
  whatsappUrl: { type: String, required: true },
});

const emit = defineEmits(["close"]);

function close() {
  emit("close");
}

function handleEscKey(event) {
  if (event.key === "Escape") close();
}

onMounted(() => document.addEventListener("keydown", handleEscKey));
onBeforeUnmount(() => document.removeEventListener("keydown", handleEscKey));
</script>

<template>
  <Teleport to="body">
    <transition name="modal-fade" appear>
      <div
        class="modal-backdrop"
        role="dialog"
        aria-modal="true"
        aria-labelledby="founder-welcome-title"
        @click.self="close"
      >
        <div class="modal-panel modal-panel--compact founder-welcome">
          <button
            type="button"
            class="modal-close-btn"
            aria-label="Fechar"
            @click="close"
          >
            <i class="fas fa-times" aria-hidden="true"></i>
          </button>

          <h4 id="founder-welcome-title" class="founder-welcome__title">
            {{ firstName ? `Olá, ${firstName}!` : "Olá!" }}
          </h4>

          <p class="founder-welcome__body">
            Sou o Edson, criei o Litterae. Se travar em algo ou tiver uma ideia,
            me chama direto aqui:
          </p>

          <div class="founder-welcome__actions">
            <a
              :href="whatsappUrl"
              target="_blank"
              rel="noopener"
              class="btn btn-whatsapp"
              @click="close"
            >
              <i class="fab fa-whatsapp" aria-hidden="true"></i>
              Chamar no WhatsApp
            </a>
            <button type="button" class="btn btn-secondary" @click="close">
              Agora não
            </button>
          </div>

          <p class="founder-welcome__hint">
            Depois, é só usar o ícone
            <i class="fab fa-whatsapp" aria-hidden="true"></i>
            no topo da tela ou o menu da sua foto.
          </p>
        </div>
      </div>
    </transition>
  </Teleport>
</template>

<style scoped>
/* Respiro e posição do X vêm do .modal-panel--compact. Aqui o texto é
   alinhado à esquerda, como uma mensagem pessoal. */
.founder-welcome {
  max-width: 26rem;
  margin-top: 10vh;
  align-items: stretch;
  text-align: left;
}

.founder-welcome__title {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-dark);
  margin: 0;
}

.founder-welcome__body {
  font-size: 0.95rem;
  color: var(--text-dark);
  line-height: 1.55;
  margin: 0;
}

.founder-welcome__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
}

.founder-welcome__actions .btn {
  gap: 0.45rem;
  text-decoration: none;
}

.founder-welcome__hint {
  font-size: var(--text-md);
  color: var(--text-light);
  margin: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}
</style>
